import React, { useEffect, useState } from 'react';
import { InternalFieldName, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import CustomModal from '../CustomModal/CustomModal';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';

interface InvoicePaymentProps {
  invoiceId: number;
  isOpen: boolean;
  setIsOpenModal: (isOpen: boolean) => void;
  refreshInvoice: () => void;
}

export interface InvoicePaymentFields {
  date: Date;
  description: string;
}

function addServerErrors<T>(
  errors: { [P in keyof T]?: string[] },
  setError: any
) {
  return Object.keys(errors).forEach((key) => {
    setError(key as keyof T, {
      type: 'server',
      message: errors[key as keyof T]!.join('. '),
    });
  });
}

export default function InvoicePayment({
  invoiceId,
  isOpen,
  setIsOpenModal,
  refreshInvoice,
}: InvoicePaymentProps) {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    reset,
  } = useForm<InvoicePaymentFields>();

  const [formErrors, setFormErrors] = useState<Record<string, any>>([]);

  const {
    user: { organization },
  } = useAuth();

  const onSubmit = async (data: InvoicePaymentFields) => {
    try {
      await api.post(
        `organizations/${organization.id}/invoices/${invoiceId}/pay`,
        data
      );

      toast.success('A ordem de serviço foi paga');
      setIsOpenModal(false);
      refreshInvoice();
    } catch (e: any) {
      if (e?.response?.data?.errors) {
        if (e?.response?.status === 422) {
          setFormErrors(e.response.data.errors);
        } else {
          toast.error(
            e?.response?.data?.errors.reduce(
              (acc: string, error: string) => acc + error,
              ''
            )
          );
        }
      } else {
        throw e;
      }
    }
  };

  useEffect(() => {
    let shouldFocus = true;
    Object.keys(formErrors || {}).forEach((field: InternalFieldName) => {
      addServerErrors(formErrors, setError);

      shouldFocus = false;
    });
  }, [formErrors]);

  return (
    <CustomModal
      modalTitle='Informe a data de pagamento'
      isOpen={isOpen}
      setIsOpenModal={setIsOpenModal}
      fullscreenOnMobile={false}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='row'>
          <div className='col-md-6'>
            <div className='mb-3'>
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor='inputLabel' className='form-label'>
                Data
              </label>
              <input
                {...register('date', { required: true })}
                className='form-control'
                placeholder='Data'
                type='date'
                required
              />
              {errors.date && (
                <div className='form-text text-danger'>
                  {errors.date.message}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='mb-3'>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor='inputLabel' className='form-label'>
            Descrição
          </label>
          <textarea
            {...register('description')}
            className='form-control'
            placeholder='Descrição'
          />
          {errors.description && (
            <div className='form-text text-danger'>
              {errors.description.message}
            </div>
          )}
        </div>
        <div className='text-end mt-3'>
          <button type='submit' className='btn btn-primary'>
            Salvar
          </button>
        </div>
      </form>
    </CustomModal>
  );
}
